<div class="p-4 bg-yellow-50" *ngIf="mobile">
    Knibble.ai is currently only available on desktop. Please visit us on your desktop to get started.
</div>
<div class="">

    <section class="overflow-hidden" style="border-bottom: solid 0px #161616;">
        <div class="bg-black w-full py-3 flex justify-between items-center">
            <div class="mx-auto w-full" style="max-width: 1100px;">
                <div class="flex items-center justify-between ">

                    <div class="flex justify-start items-center py-2">

                        <div class="w-auto mr-8">
                            <div class="flex flex-wrap items-center">
                                <div class="w-auto pr-2 flex text-white ">
                                    <a href="/" class="mr-2">
                                        <img src="assets/logo-re2.svg" alt="" style="width:25px">
                                    </a>
                                    <div class="text-xl font-semibold">Knibble</div>
                                </div>
                            </div>
                        </div>



                    </div>

                    <div class="w-auto hidden lg:block">
                        <ul class="flex items-center">
                            <li class="mr-14 font-medium text-gray-100 hover:text-gray-200 tracking-tight"><a
                                    (click)="scrollToDiv('features')">Features</a>
                            </li>
                            <li class="mr-14 font-medium text-white hover:text-gray-200 tracking-tight"><a
                                    href="/pricing">Pricing</a>
                            </li>
                            <!-- <li class="mr-14 font-medium text-white hover:text-gray-200 tracking-tight"><a
                                    href="#">Demo</a>
                            </li> -->

                            <li class="mr-14 font-medium text-white hover:text-gray-200 tracking-tight"><a
                                    (click)="scrollToDiv('chatbot')">Chatbot</a>
                            </li>
                            <li
                                class="mr-8 font-medium text-white hover:text-gray-200 tracking-tight border- border-gray-700 pr-8">
                                <a href="https://knibble-ai.getrewardful.com/signup">Affiliate</a>
                            </li>

                        </ul>
                    </div>

                    <div class="w-auto">
                        <div class="flex flex-wrap items-center">
                            <ul class="flex items-center mr-8">
                                <li class="font-medium text-white hover:text-gray-200 tracking-tight"><a
                                        href="https://chatdocsfa8e9a49-fa8e9a49-dev.auth.us-east-1.amazoncognito.com/login?response_type=code&client_id=1av89dcacj1d5gqu509i4d7prt&redirect_uri={{redirecturl}}">Login</a>
                                </li>

                            </ul>

                            <div class="w-auto hidden lg:block">
                                <div class="inline-block"><a style="border:solid 1px var(--app-theme-color);"
                                        class="inline-block px-3 py-2 text-white  text-center tracking-tight bg-inherit hover:bg-indigo-600 rounded-lg focus:ring-4 focus:ring-indigo-300 transition duration-200"
                                        href="https://chatdocsfa8e9a49-fa8e9a49-dev.auth.us-east-1.amazoncognito.com/signup?response_type=code&client_id=1av89dcacj1d5gqu509i4d7prt&redirect_uri={{redirecturl}}">Sign
                                        up</a></div>
                            </div>
                            <!-- <div class="w-auto lg:hidden">
                                <a href="#">
                                    <svg class="navbar-burger text-indigo-600" width="51" height="51"
                                        viewbox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="56" height="56" rx="28" fill="currentColor"></rect>
                                        <path d="M37 32H19M37 24H19" stroke="white" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </a>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </section>

    <section class="flex justify-center items-center w-full bg-black pt-16"
        style="border-bottom: solid 1px #272727; padding-bottom: 70px;">


        <div _ngcontent-aey-c79="" class="bg-black flex flex-col justify-center items-center -ml-1"
            style="width: 1200px;">
            <span _ngcontent-aey-c79="" class="inline-block mb-4 px-0 py-1 text-gray-400 font-semibold" style="
            color: #ceced0;
        "> <i class="fas fa-bolt mr-2 text-yellow-300"></i>Powered by GPT</span>
            <h1 _ngcontent-aey-c79="" class="mb-4 text-5xl text-white  text-center"
                style="font-family: Poppins; font-size: 53px; line-height: 1.2; font-weight: 500;">
                <span>AI Powered</span> <br _ngcontent-aey-c79="">Knowledge Base &amp; Chatbot
            </h1>

            <div class="flex justify-center items-center gap-x-3 mb-4">

                <a _ngcontent-aey-c79=""
                    class="inline-block px-4 py-3 mt-3 text-white font- tracking-tight bg-inherit hover:bg-indigo-600 rounded-lg focus:ring-4 focus:ring-indigo-400 transition duration-200"
                    style="background:  var(--app-theme-color);"
                    href="https://chatdocsfa8e9a49-fa8e9a49-dev.auth.us-east-1.amazoncognito.com/signup?response_type=code&amp;client_id=1av89dcacj1d5gqu509i4d7prt&amp;redirect_uri={{redirecturl}}">Get
                    Started for free <i _ngcontent-aey-c79="" class="fas fa-arrow-right ml-2"></i></a>

                <!-- <a _ngcontent-aey-c79=""
                    class="inline-block px-4 py-3 mt-3 text-white font- tracking-tight bg-inherit hover:bg-indigo-600 rounded-lg focus:ring-4 focus:ring-indigo-400 transition duration-200"
                    style="border: solid 1px white;"
                    href="https://chatdocsfa8e9a49-fa8e9a49-dev.auth.us-east-1.amazoncognito.com/signup?response_type=code&amp;client_id=1av89dcacj1d5gqu509i4d7prt&amp;redirect_uri={{redirecturl}}">Watch
                    Demo <i _ngcontent-aey-c79="" class="fa-solid text-red-400 fa-play ml-2"></i></a> -->

            </div>
        </div>

    </section>

    <section class="flex justify-center items-center w-full bg-white pb-20 pt-16"
        style="border-bottom: solid 0px #272727;">


        <div _ngcontent-aey-c79="" class="bg-white flex flex-col justify-center items-center" style="width: 1300px;">

            <div _ngcontent-vsd-c51="" id="how-it-works" class="relative mx-auto">
                <div _ngcontent-vsd-c51="" class="lg:max-w-6xl lg:mx-auto">
                    <div _ngcontent-vsd-c51="" class="relative inline-flex sm:inline rounded-md overflow-hidden"><span
                            _ngcontent-vsd-c51=""
                            class="bg-gradient-to-r from-[#fff5a0] via-[#ff9df5] to-[#ff9d5e] blur-lg filter opacity-80 w-full h-full absolute inset-0"></span><span
                            _ngcontent-vsd-c51="" class="relative font-semibold">

                            <iframe class="rounded overflow-hidden" style="margin-top:-100px"
                                src="https://player.vimeo.com/video/855903538?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                                width="1100" height="619" frameborder="0" allow=""></iframe>
                            <!-- <video _ngcontent-vsd-c51="" style="margin-top:-100px" controls="true"
                                poster="assets/mains.png" class="w-full border rounded-lg">
                                <source _ngcontent-vsd-c51=""
                                    src="https://s3.amazonaws.com/knibble.ai.assets/KnibbleDemo.mp4" type="video/mp4">
                                Your browser does not support the video tag.
                            </video> -->

                        </span></div>
                </div>
            </div>


            <!-- <script src="https://player.vimeo.com/api/player.js"></script> -->

        </div>
    </section>
    <section class="hidden flex justify-center items-center w-full bg-black py-24"
        style="border-bottom: solid 1px #272727;">


        <div _ngcontent-aey-c79="" class="pt-12 pb-12 bg-black overflow-hidden" style="width: 1000px;">
            <div _ngcontent-aey-c79="" class="container  mx-auto">
                <div _ngcontent-aey-c79="" class="flex flex-col justify-center items-center">
                    <div _ngcontent-aey-c79="" class="w-full relative">
                        <div _ngcontent-aey-c79="" class="flex flex-col justify-center items-center relative"><span
                                _ngcontent-aey-c79="" class="inline-block mb-4 px-0 py-1 text-gray-400 font-semibold"
                                style="
            color: #be90ff;
        "> Powered by chatgpt</span>
                            <h1 _ngcontent-aey-c79=""
                                class="font-heading mb-4 text-5xl md:text-6xl text-white tracking-tighter align-middle text-center"
                                style="font-family: Poppins; font-size: 60px; line-height: 1.2; font-weight: 500;">Your
                                AI Powered <br _ngcontent-aey-c79="">Knowledge Base &amp; Chatbot</h1>
                            <p _ngcontent-aey-c79=""
                                class="text-gray-400 font-thin px-24 text-lg align-middle text-center"> Chat over pdf
                                files, web pages, text files and more. Create customizable chatbots and embed on any
                                website in minutes. </p>
                            <div _ngcontent-aey-c79="" class="flex flex-wrap -m-2 mb-14 mt-4">
                                <div _ngcontent-aey-c79="" class="w-auto p-2"><a _ngcontent-aey-c79=""
                                        class="inline-block px-4 py-3 text-white font- tracking-tight bg-indigo-500 hover:bg-indigo-600 rounded-full focus:ring-4 focus:ring-indigo-400 transition duration-200"
                                        style="background: #7f3fdb;"
                                        href="https://chatdocsfa8e9a49-fa8e9a49-dev.auth.us-east-1.amazoncognito.com/signup?response_type=code&amp;client_id=1av89dcacj1d5gqu509i4d7prt&amp;redirect_uri={{redirecturl}}">Get
                                        Started for free <i _ngcontent-aey-c79=""
                                            class="fas fa-arrow-right ml-2"></i></a></div>
                            </div>
                        </div>
                    </div>
                    <div _ngcontent-aey-c79="" class="w-full"></div>
                </div>
            </div>
        </div>

    </section>


    <section class=" justify-center items-center w-full bg-black py-4 hidden" style="border-bottom: solid 1px #272727;">

        <div class="pt-12 pb-12 bg-black overflow-hidden" style="width: 1000px;">
            <div class="container px-12 mx-auto">
                <div class="flex flex-col justify-center items-center">
                    <div class="w-full relative">
                        <div class="flex flex-col justify-center items-center relative">
                            <span class="inline-block mb-4 px-0 py-1 text-gray-400 font-semibold">
                                <i class="fas fa-bolt mr-2 text-yellow-300"></i>
                                Powered
                                by chatgpt</span>
                            <h1 class="font-heading mb-4 text-5xl md:text-6xl text-white tracking-tighter align-middle text-center"
                                style="font-family: 'Poppins'; font-size: 60px; line-height: 1.2;font-weight: 500;">Your
                                AI
                                Powered <br>Knowledge Base & Chatbot</h1>
                            <p class="text-gray-400 font-thin px-24 text-lg align-middle text-center">
                                Chat over pdf files, web pages, text files and more. Create customizable chatbots
                                and embed on any website in minutes.
                            </p>
                            <div class="flex flex-wrap -m-2 mb-14 mt-4">
                                <div class="w-auto p-2"><a style="background: #0284FF;"
                                        class="inline-block px-4 py-3 text-white font- tracking-tight bg-indigo-500 hover:bg-indigo-600 rounded-full focus:ring-4 focus:ring-indigo-400 transition duration-200"
                                        href="https://chatdocsfa8e9a49-fa8e9a49-dev.auth.us-east-1.amazoncognito.com/signup?response_type=code&client_id=1av89dcacj1d5gqu509i4d7prt&redirect_uri={{redirecturl}}">Get
                                        Started for free
                                        <i class="fas fa-arrow-right ml-2"></i>
                                    </a></div>

                            </div>




                            <!-- <div class="max-w-md">
                                <div class="flex flex-wrap -m-1.5">
                                    <div class="w-auto p-1.5">
                                        <div class="flex flex-wrap">
                                            <div class="w-auto">
                                                <img src="assets/basko-assets/images/headers/avatar.png" alt="">
                                            </div>
                                            <div class="w-auto -ml-5">
                                                <img src="assets/basko-assets/images/headers/avatar2.png" alt="">
                                            </div>
                                            <div class="w-auto -ml-5">
                                                <img src="assets/basko-assets/images/headers/avatar3.png" alt="">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex-1 p-1.5">
                                        <p class="text-white tracking-tight">Join other 12k+ Marketers and start
                                            building brands
                                            reputation now.</p>
                                    </div>
                                </div>
                            </div> -->
                        </div>

                        <img src="assets/hero-mat/message-box-1.svg" alt="" class="absolute w-32"
                            style="right:0;bottom:0">
                        <img src="assets/hero-mat/question.svg" alt="" class="absolute w-8" style="left:30px;top:44px">
                        <img src="assets/hero-mat/bulb.svg" alt="" class="absolute w-16" style="right:0;bottom:44px">
                        <img src="assets/hero-mat/message-box-2.svg" alt="" class="absolute w-32"
                            style="left:-50px;top:0">

                    </div>
                    <!-- <div class="w-full md:w-6/12 p-0 relative rounded-xl overflow-hidden" *ngIf="!mobile"> -->
                    <!-- <img src="assets/loop-loader.png" alt="" class="absolute -ml-12" style="    z-index: 99;
                        margin-left: -225px;
                        margin-top: -139px;
                        width: 612px;
                        opacity: 19%;"> -->
                    <!-- <img class="transform hover:-translate-y-2 transition duration-500 relative w-full"
                            style="z-index: 999; width:650px" src="assets/online-chatbot3.svg" alt="">
                    </div> -->

                    <div class="w-full">



                        <!-- <img src="assets/grass.svg" alt="" class="w-full" /> -->

                    </div>
                </div>
            </div>
        </div>
    </section>



    <section class="py-0 bg-white overflow-hidden">

        <section class="py-0 bg-gray-00 sm:py-16 lg:py-20">
            <div class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">


                <div class="flex flex-col items-center max-w-md mx-auto mt-8 lg:mt-20 lg:flex-row lg:max-w-none">
                    <div
                        class="relative flex-1 justify-center items-center w-full overflow-hidden bg-inherit border-0 border-gray-200 rounded-2xl">
                        <div class="py-8 px-6 flex flex-col justify-center items-center shadow-sm">
                            <!-- <img src="assets/chatdocs2.svg" style="width:65px" class="mr-2" /> -->
                            <i class="fa-light fa-file text-5xl text-gray-900"></i>
                            <i class="fa-solid fa-message text-lg text-yellow-500 relative -top-10 -left-6"></i>
                            <p class="mt-4 text-md font-medium text-gray-900 font-pj" style="text-align: center;">
                                Get
                                instant
                                answers from pdfs and
                                webpages. Chat over multiple resources at once.<br><br></p>
                        </div>
                    </div>


                    <div class="block -my-1 lg:hidden">
                        <svg class="w-4 h-auto text-gray-300" viewBox="0 0 16 32" fill="none" stroke="currentColor"
                            xmlns="http://www.w3.org/2000/svg">
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(0.83205 0.5547 0.5547 -0.83205 1 21)" />
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(0.83205 0.5547 0.5547 -0.83205 1 14)" />
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(0.83205 0.5547 0.5547 -0.83205 1 7)" />
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(0.83205 0.5547 0.5547 -0.83205 1 0)" />
                        </svg>
                    </div>

                    <div class="hidden lg:block lg:-mx-2">
                        <svg class="w-auto h-4 text-gray-300" viewBox="0 0 81 16" fill="none" stroke="currentColor"
                            xmlns="http://www.w3.org/2000/svg">
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(-0.5547 0.83205 0.83205 0.5547 11 1)" />
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(-0.5547 0.83205 0.83205 0.5547 46 1)" />
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(-0.5547 0.83205 0.83205 0.5547 81 1)" />
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(-0.5547 0.83205 0.83205 0.5547 18 1)" />
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(-0.5547 0.83205 0.83205 0.5547 53 1)" />
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(-0.5547 0.83205 0.83205 0.5547 25 1)" />
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(-0.5547 0.83205 0.83205 0.5547 60 1)" />
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(-0.5547 0.83205 0.83205 0.5547 32 1)" />
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(-0.5547 0.83205 0.83205 0.5547 67 1)" />
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(-0.5547 0.83205 0.83205 0.5547 39 1)" />
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(-0.5547 0.83205 0.83205 0.5547 74 1)" />
                        </svg>
                    </div>

                    <div class="relative flex-1 w-full">
                        <div class="absolute -inset-4">
                            <div class="w-full h-full mx-auto rotate-180 opacity-20 blur-lg filter"
                                style="background: linear-gradient(90deg, #44ff9a -0.55%, #44b0ff 22.86%, #8b44ff 48.36%, #ff6644 73.33%, #ebff70 99.34%)">
                            </div>
                        </div>

                        <div class="relative overflow-hidden bg-white border-0 border-gray-200 rounded-2xl">
                            <div
                                class="relative flex-1 justify-center items-center w-full overflow-hidden bg-inherit border-0 border-gray-200 rounded-2xl">
                                <div class="py-8 px-6 flex flex-col justify-center items-center shadow-sm">
                                    <!-- <img src="assets/chatbotm.svg" style="width:65px" class="mr-2" /> -->
                                    <i class="fa-duotone fa-code fa-3x text-gray-900"></i>
                                    <p class="mt-4 text-md font-medium text-gray-900 font-pj"
                                        style="text-align: center;">Create
                                        a chatbot for your website or app in
                                        minutes.
                                        Customize
                                        the style to match your brand and color scheme.<br></p>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="hidden lg:block lg:-mx-2">
                        <svg class="w-auto h-4 text-gray-300" viewBox="0 0 81 16" fill="none" stroke="currentColor"
                            xmlns="http://www.w3.org/2000/svg">
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(-0.5547 0.83205 0.83205 0.5547 11 1)" />
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(-0.5547 0.83205 0.83205 0.5547 46 1)" />
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(-0.5547 0.83205 0.83205 0.5547 81 1)" />
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(-0.5547 0.83205 0.83205 0.5547 18 1)" />
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(-0.5547 0.83205 0.83205 0.5547 53 1)" />
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(-0.5547 0.83205 0.83205 0.5547 25 1)" />
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(-0.5547 0.83205 0.83205 0.5547 60 1)" />
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(-0.5547 0.83205 0.83205 0.5547 32 1)" />
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(-0.5547 0.83205 0.83205 0.5547 67 1)" />
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(-0.5547 0.83205 0.83205 0.5547 39 1)" />
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(-0.5547 0.83205 0.83205 0.5547 74 1)" />
                        </svg>
                    </div>

                    <div class="block -my-1 lg:hidden">
                        <svg class="w-4 h-auto text-gray-300" viewBox="0 0 16 32" fill="none" stroke="currentColor"
                            xmlns="http://www.w3.org/2000/svg">
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(0.83205 0.5547 0.5547 -0.83205 1 21)" />
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(0.83205 0.5547 0.5547 -0.83205 1 14)" />
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(0.83205 0.5547 0.5547 -0.83205 1 7)" />
                            <line y1="-0.5" x2="18.0278" y2="-0.5"
                                transform="matrix(0.83205 0.5547 0.5547 -0.83205 1 0)" />
                        </svg>
                    </div>

                    <div class="relative flex-1 w-full overflow-hidden bg-inherit border-0 border-gray-200 rounded-2xl">

                        <div class="py-8 px-6 flex flex-col justify-center items-center shadow-sm">
                            <!-- <div
                            class="inline-flex items-center justify-center w-10 h-10 text-base font-bold text-white bg-gray-900 rounded-xl font-pj">
                            2</div> -->
                            <!-- <img src="assets/share.svg" style="width:65px" class="mr-2" /> -->
                            <i class="fa-regular fa-share-nodes text-5xl text-gray-900"></i>
                            <p class="mt-4 text-md font-medium text-gray-900 font-pj" style="text-align: center;">
                                Easily manage your knowledge base
                                and share it with your team or customers.<br><br></p>
                        </div>

                    </div>
                </div>
            </div>
        </section>

    </section>

    <section class="py-12 lg:py-28 overflow-hidden">
        <section class="py-12 bg-white sm:py-16 lg:py-20 mt-10" id="features">
            <div class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
                <div class="text-center">
                    <h2 class="text-3xl font-bold leading-tight text-gray-900 sm:text-4xl xl:text-5xl font-pj">Features
                    </h2>
                    <!-- <p class="mt-4 text-base leading-7 text-gray-600 sm:mt-8 font-pj">Lorem ipsum dolor sit amet, consectetur
                    adipis elit</p> -->
                </div>

                <div
                    class="grid grid-cols-1 mt-4 text-center sm:mt-16 sm:grid-cols-2 sm:gap-x-12 gap-y-12 md:grid-cols-3 md:gap-0 xl:mt-24">
                    <div class="md:p-8 lg:p-14 flex flex-col justify-center items-center">
                        <img src="assets/modules/svgs/timeline-chart.svg" style="width:75px" />

                        <h3 class="mt-12 text-2xl font-bold text-gray-900 font-pj">Multiple Documents</h3>
                        <p class="mt-2 text-base text-gray-600 font-pj">Chat over multiple documents at once. Add
                            multiple
                            pdf
                            files or text files and get instant answers.

                        </p>
                    </div>

                    <div
                        class="md:p-8 lg:p-14 md:border-l flex flex-col justify-center items-center  md:border-gray-200">
                        <img src="assets//webpage.svg" style="width:75px" />
                        <h3 class="mt-12 text-2xl font-bold text-gray-900 font-pj">Add Webpages</h3>
                        <p class="mt-2 text-base text-gray-600 font-pj">Have a webpage you want to chat over? Add the
                            url
                            and
                            chat over the webpage.</p>
                    </div>

                    <div
                        class="md:p-8 lg:p-14 md:border-l md:border-gray-200 flex flex-col justify-center items-center">
                        <img src="assets/cb.svg" style="width:75px" />
                        <h3 class="mt-12 text-2xl font-bold text-gray-900 font-pj">Customizable Chatbot
                        </h3>
                        <p class="mt-2 text-base text-gray-600 font-pj">Customize your chatbot to your liking. Change
                            the
                            color,
                            add your own logo and more.

                        </p>
                    </div>

                    <div
                        class="md:p-8 lg:p-14 md:border-t md:border-gray-200 flex flex-col justify-center items-center">
                        <img src="assets/history.svg" style="width:75px" />
                        <h3 class="mt-12 text-2xl font-bold text-gray-900 font-pj">Chat History
                        </h3>
                        <p class="mt-2 text-base text-gray-600 font-pj">All your chat history is saved. You can access
                            it
                            anytime and continue from where you left off.

                        </p>
                    </div>

                    <div
                        class="md:p-8 lg:p-14 md:border-l md:border-gray-200 md:border-t flex flex-col justify-center items-center">
                        <img src="assets/text.svg" style="width:75px" />
                        <h3 class="mt-12 text-2xl font-bold text-gray-900 font-pj">Text Blocks
                        </h3>
                        <p class="mt-2 text-base text-gray-600 font-pj">Copy and paste text from any source and chat
                            over
                            it.
                            You can also add text files.

                        </p>
                    </div>

                    <div
                        class="md:p-8 lg:p-14 md:border-l md:border-gray-200 md:border-t flex flex-col justify-center items-center">
                        <img src="assets/paragraph.svg" style="width:75px" />
                        <h3 class="mt-12 text-2xl font-bold text-gray-900 font-pj">Summarize</h3>
                        <p class="mt-2 text-base text-gray-600 font-pj">Summarize large documents and extract the most
                            important
                            information with a click of a button.

                        </p>
                    </div>
                </div>
            </div>
        </section>
    </section>



    <div class="features-wrapper w-full bg-gray-50 pt-2 mt-12 mb-24 flex flex-col justify-center items-center mx-auto"
        *ngIf="!mobile" style="background:#fff !important; display: nonne; " id="chatbot">

        <div style="max-width: 1300px;" class="flex flex-col w-full justify-center items-center">

            <div class="flex justify-center items-center sm:text-center border-0 pb-2 mb-2 w-full">
                <!-- <h2 class="text-base font-semibold leading-7 text-indigo-600">Pricing</h2> -->
                <p class="mt-2 text-xl font-bold tracking-tight text-gray-800 sm:text-5xl">Your chatbot, your
                    style.
                </p>
            </div>



            <div class="mb-4 text-lg  text-gray-900 font-normal"
                style="font-size: 18px;width:800px; text-align: center;">

                Customize every aspect of your chatbot. Choose the color, background, logo and more. Make it your
                own and embed on any webpage. Try out the customizations below.


            </div>

            <div class="p-3 flex justify-center items-center mb-10">

                <a href="https://s3.amazonaws.com/knibble.ai.assets/web-embed.mp4"
                    class="flex justify-center items-center">
                    <i class="fa fa-play-circle text-lg text-red-500 mr-1"></i>How to embed?
                </a>

            </div>


            <div class="relative mt-10" style="max-width: 1350px;">
                <div class="absolute inset-0 h-2/3 bg-gray-50"></div>
                <div class="relative mx-auto">
                    <div class="lg:max-w-6xl lg:mx-auto">
                        <div class="relative inline-flex sm:inline">
                            <span
                                class="bg-gradient-to-r from-[#fff5a0] via-[#ff9df5] to-[#ff9d5e] blur-lg filter opacity-80 w-full h-full absolute inset-0"></span>
                            <span class="relative font-semibold">

                                <div id="feature-container"
                                    class="py-8 flex w-full bg-white  justify-between items-center h-full bg-inherit text-gray-900 px-0 mx-auto">
                                    <div class="w-7/12 border-r px-16 py-0 h-full flex flex-col  justify-center items-center"
                                        style="font-weight: 400 !important;">

                                        <!-- <span class="text-xs text-gray-400">
            {{embed?.embed_uuid}}
        </span> -->


                                        <div class="w-full h-auto shadow flex flex-col p-0  overflow-hidden {{embed?.rounded}}"
                                            style="max-width: 400px;"
                                            style="background:{{embed?.bg_color}}; border:solid 1px {{embed?.border_color}}; border-radius:{{embed?.rounded}}%">

                                            <div class="p-3 flex justify-between items-center"
                                                style="background: {{embed?.header_color}};">

                                                <div class="flex justify-start items-center">

                                                    <div>
                                                        <img src="assets/bot-1.svg" class="w-14"
                                                            *ngIf="embed?.logo === 'default' || embed?.logo_path === '' || embed?.logo_path === undefined" />
                                                        <img src="{{embed?.logo}}" class="w-14"
                                                            *ngIf="embed?.logo !== 'default' && embed?.logo_path !== '' && embed?.logo_path !== undefined" />
                                                    </div>
                                                    <div class="flex flex-col justify-start">
                                                        <div class="ml-3 text-lg font-semibold"
                                                            style="color: {{embed?.header_text_color}};">
                                                            {{embed?.title}}
                                                        </div>

                                                        <div class="font-normal ml-3 mt-1 text-sm"
                                                            *ngIf="embed?.subtitle !== ''"
                                                            style="color: {{embed?.header_text_color}}; opacity: 70%;">
                                                            {{embed?.subtitle}}
                                                        </div>

                                                    </div>
                                                </div>

                                                <div class="px-2" style="color: {{embed?.header_text_color}};">

                                                    <i class="fa-light fa-refresh text-xl cursor-pointer"></i>

                                                </div>


                                            </div>

                                            <div class="w-full px-4 py-2 bg-gray-100 text-sm"
                                                style="color: {{embed?.sub_header_text_color}}; background: {{embed?.sub_header_bg_color}}"
                                                *ngIf="embed?.sub_header_text !== '' && embed?.sub_header_text !== null && embed?.sub_header_text !== undefined">
                                                {{embed?.sub_header_text}}
                                            </div>


                                            <div class="p-0">

                                                <div class="p-3   border-0 w-full flex ">
                                                    <div class="p-3 my-2 w-fit  text-white rounded-lg"
                                                        style="background: {{embed?.bot_msg_bg_color}};">

                                                        <!-- <img src="assets/user.svg" class="w-6 h-6  mr-4" /> -->

                                                        <div class="text-sm"
                                                            style="color:{{embed?.bot_msg_text_color}}">

                                                            {{embed?.default_message}}

                                                        </div>

                                                    </div>
                                                </div>

                                                <div *ngFor="let message of sample_chat_messages" class="px-3 border-0">

                                                    <div class="p-0 rounded-lg  border-0 w-full flex justify-end items-end"
                                                        *ngIf="message.actor === 'user'">
                                                        <div class="p-3 my-2 w-fit rounded-lg"
                                                            style="background: {{embed?.user_msg_bg_color}};">

                                                            <!-- <img src="assets/user.svg" class="w-6 h-6  mr-4" /> -->

                                                            <div class="text-sm"
                                                                style="color:{{embed?.user_msg_text_color}}">

                                                                {{message.text}}

                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div class="p-0   border-0 w-full flex "
                                                        *ngIf="message.actor === 'bot'">
                                                        <div class="p-3 my-2 w-fit  text-white rounded-lg"
                                                            style="background: {{embed?.bot_msg_bg_color}};">

                                                            <!-- <img src="assets/user.svg" class="w-6 h-6  mr-4" /> -->

                                                            <div class="text-sm"
                                                                style="color:{{embed?.bot_msg_text_color}}">

                                                                <div class="custom-link" [innerHTML]="message.text">
                                                                </div>

                                                            </div>

                                                        </div>
                                                    </div>







                                                </div>
                                                <div class="h-40 w-full">

                                                </div>

                                                <!-- Aravs -->

                                                <div class="relative flex border m-2 py-1 rounded-lg"
                                                    style="background: {{embed?.send_bar_background}};">

                                                    <textarea type="text" placeholder="{{embed?.placeholder}}"
                                                        resize="none" rows="1"
                                                        style="width:90%;color:{{embed?.send_bar_text_color}}"
                                                        class="send_box w-full focus:outline-none focus:placeholder-gray-400 text-gray-600 placeholder-gray-600 pl-3 border-0 rounded-none py-3 bg-inherit flex justify-start items-center text-sm"></textarea>
                                                    <div class=" right-0 items-center">

                                                        <button type="button"
                                                            class="inline-flex items-center bg-inherit justify-center rounded-lg px-3 py-3 mx-2 transition duration-500 ease-in-out  bg-blue-500 hover:bg-blue-400 focus:outline-none">

                                                            <i class=" {{embed?.send_icon}}"
                                                                style="color:{{embed?.send_icon_bg_color}}"></i>
                                                        </button>
                                                    </div>

                                                    <!-- <input type="text" placeholder="{{embed?.placeholder}}"
                    style="color:{{embed?.send_bar_text_color}}; ::placeholder{color:red}"
                    value="Hello!"
                    class="w-full focus:outline-none focus:placeholder-gray-400 text-gray-600 placeholder-gray-600 pl-4 border-0 bg-inherit  border-gray-900 rounded-md py-3">
                <div class="absolute right-0 items-center inset-y-0 hidden sm:flex">

                    <button type="button"
                        class="inline-flex items-center justify-center rounded-lg px-4 py-3 m-3 transition duration-500 ease-in-out  bg-blue-500 hover:bg-blue-400 focus:outline-none"
                        style="background: {{embed?.send_icon_bg_color}}; color:{{embed?.send_icon_color}}">

                        <i class=" {{embed?.send_icon}}"></i>
                    </button>
                </div> -->
                                                </div>

                                            </div>





                                        </div>

                                        <div class="flex justify-end items-end mt-3 h-auto pb-4 w-full">

                                            <button
                                                class=" w-16 h-16 rounded-full bg-gray-800 text-2xl flex justify-center items-center"
                                                style="z-index:999999; background: {{embed.bubble_bg_color}};">
                                                <i class="{{embed.bubble_icon}}"
                                                    style="color:{{embed.bubble_text_color}}"></i>
                                            </button>

                                        </div>





                                    </div>

                                    <div class="w-5/12 h-full overflow-y-scroll px-16 py-0 flex flex-col justify-start items-start"
                                        style="height:600px">

                                        <div class="w-full my-2">
                                            <label class="edit_bot_label text-lg font-semibold mb-4">Customize
                                            </label><br>
                                            <label
                                                class="edit_bot_label text-base font-semibold mb-1 text-gray-800">Logo</label>
                                            <div class="flex flex-col justify-start items-start ">

                                                <div class="p-2 border rounded flex justify-center items-center">

                                                    <a class="p-0 m-0">
                                                        <div class="avatar mr-0">
                                                            <div class="">
                                                                <img src="assets/bot-1.svg" cors="anonymous"
                                                                    style="min-width: 50px; max-width: 50px;" />
                                                            </div>

                                                        </div>
                                                    </a>





                                                </div>





                                            </div>
                                        </div>

                                        <div class="w-full flex justify-start items-center gap-x-3 my-3">

                                            <label class="edit_bot_label text-base font-normal mb-1">Logo
                                                Rounded</label>
                                            <input type="checkbox" class="toggle toggle-success" />

                                        </div>

                                        <div class="w-full my-2">

                                            <label class="edit_bot_label text-base font-normal mb-1">Bot Title</label>
                                            <input type="text" class="edit_bot_input w-full p-3 mt-1 border rounded"
                                                [(ngModel)]="embed.title" (keyup)="saveBotSettings()" />

                                        </div>

                                        <div class="w-full my-2">

                                            <label class="edit_bot_label text-base font-normal mb-1">Bot
                                                Subtitle</label>
                                            <input type="text" class="edit_bot_input w-full p-3 mt-1 border rounded"
                                                [(ngModel)]="embed.subtitle" (keyup)="saveBotSettings()" />

                                        </div>

                                        <div class="w-full mt-3">

                                            <label class="edit_bot_label text-base font-normal mb-1">Bot Default
                                                Message</label>
                                            <input type="text" class="edit_bot_input w-full p-3 mt-1 border rounded"
                                                [(ngModel)]="embed.default_message" (keyup)="saveBotSettings()" />

                                        </div>

                                        <div class="w-full mt-3">

                                            <label class="edit_bot_label text-base font-normal mb-1">Subheader
                                                Text</label>
                                            <input type="text" class="edit_bot_input w-full p-3 mt-1 border rounded"
                                                [(ngModel)]="embed.sub_header_text" (keyup)="saveBotSettings()" />

                                        </div>

                                        <div class="w-full mt-3">

                                            <label class="edit_bot_label text-base font-normal mb-1">Message Placeholder
                                                Text</label>
                                            <input type="text" class="edit_bot_input w-full p-3 mt-1 border rounded"
                                                [(ngModel)]="embed.placeholder" (keyup)="saveBotSettings()" />

                                        </div>

                                        <div class="w-full mt-3 flex flex-col">

                                            <label class="edit_bot_label text-base font-normal mb-1">Header Background
                                                Color</label>
                                            <input type="color" class=" mt-1" value="embed?.header_color"
                                                [(ngModel)]="embed.header_color" />

                                        </div>

                                        <div class="w-full mt-3 flex flex-col">

                                            <label class="edit_bot_label text-base font-normal mb-1">Header Text
                                                Color</label>
                                            <input type="color" class=" mt-1" value="embed?.header_text_color"
                                                [(ngModel)]="embed.header_text_color" />

                                        </div>

                                        <div class="w-full mt-3 flex flex-col">

                                            <label class="edit_bot_label text-base font-normal mb-1">Subheader Text
                                                Color</label>
                                            <input type="color" class=" mt-1" value="embed?.sub_header_text_color"
                                                [(ngModel)]="embed.sub_header_text_color" />

                                        </div>


                                        <div class="w-full mt-3 flex flex-col">

                                            <label class="edit_bot_label text-base font-normal mb-1">Subheader
                                                Background
                                                Color</label>
                                            <input type="color" class=" mt-1" value="embed?.sub_header_bg_color"
                                                [(ngModel)]="embed.sub_header_bg_color" />

                                        </div>

                                        <div class="w-full mt-3 flex flex-col">

                                            <label class="edit_bot_label text-base font-normal mb-1">Chat Window
                                                Background
                                                Color</label>
                                            <input type="color" class=" mt-1" value="embed.bg_color"
                                                [(ngModel)]="embed.bg_color" />

                                        </div>

                                        <div class="w-full mt-3 flex flex-col">

                                            <label class="edit_bot_label text-base font-normal mb-1">Chat Window Border
                                                Color</label>
                                            <input type="color" class=" mt-1" value="embed.border_color"
                                                [(ngModel)]="embed.border_color" />

                                        </div>

                                        <div class="w-full mt-3 flex flex-col">


                                            <label class="edit_bot_label text-base font-normal mb-1">Chat Window
                                                Roundedness</label>
                                            <input type="range" min="0" max="10" value="5" class="range" step="1"
                                                [(ngModel)]="embed.rounded" />

                                        </div>


                                        <div class="w-full mt-3 flex flex-col">

                                            <label class="edit_bot_label text-base font-normal mb-1">Send Bar Backgrond
                                                Color</label>
                                            <input type="color" class=" mt-1" value="embed.send_bar_background"
                                                [(ngModel)]="embed.send_bar_background" />

                                        </div>


                                        <div class="w-full mt-3 flex flex-col">

                                            <label class="edit_bot_label text-base font-normal mb-1">Send Bar Text
                                                Color</label>
                                            <input type="color" class=" mt-1" value="embed.send_bar_text_color"
                                                [(ngModel)]="embed.send_bar_text_color" />

                                        </div>

                                        <hr class="w-full h-1 bg-gray-100 mt-4">

                                        <div class="w-full mt-3 flex flex-col">

                                            <label class="edit_bot_label text-base font-normal mb-1">Bot Message
                                                Background
                                                Color</label>
                                            <input type="color" class=" mt-1" value="embed.bot_msg_bg_color"
                                                [(ngModel)]="embed.bot_msg_bg_color" />

                                        </div>

                                        <div class="w-full mt-3 flex flex-col">

                                            <label class="edit_bot_label text-base font-normal mb-1">Bot Message Text
                                                Color</label>
                                            <input type="color" class=" mt-1" value="embed.bot_msg_text_color"
                                                [(ngModel)]="embed.bot_msg_text_color" />

                                        </div>

                                        <div class="w-full mt-3 flex flex-col">

                                            <label class="edit_bot_label text-base font-normal mb-1">User Message
                                                Background
                                                Color</label>
                                            <input type="color" class=" mt-1" value="embed.user_msg_bg_color"
                                                [(ngModel)]="embed.user_msg_bg_color" />

                                        </div>

                                        <div class="w-full mt-3 flex flex-col">

                                            <label class="edit_bot_label text-base font-normal mb-1">User Message Text
                                                Color</label>
                                            <input type="color" class=" mt-1" value="embed.user_msg_text_color"
                                                [(ngModel)]="embed.user_msg_text_color" />

                                        </div>

                                        <hr class="w-full h-1 bg-gray-100 mt-4">

                                        <div class="w-full mt-3 flex flex-col">

                                            <label class="edit_bot_label text-base font-normal mb-1">Send Icon
                                                Color</label>
                                            <input type="color" class=" mt-1" value="embed.send_icon_bg_color"
                                                [(ngModel)]="embed.send_icon_bg_color" />

                                        </div>

                                        <!-- <div class="w-full mt-3 flex flex-col">
            
                                    <label class="edit_bot_label text-base font-normal mb-1">Send Icon Color</label>
                                    <input type="color" class=" mt-1" value="embed.send_icon_color"
                                        [(ngModel)]="embed.send_icon_color"  />
            
                                </div> -->

                                        <div class="w-full mt-3 flex flex-col">

                                            <label class="edit_bot_label text-base font-normal mb-1">Send Button Icon
                                            </label>

                                            <div class="flex gap-x-4">

                                                <i class="fa-solid fa-paper-plane text-lg cursor-pointer"
                                                    [ngClass]="{'text-gray-400': embed?.send_icon !== 'fa-solid fa-paper-plane', 'text-primary': embed?.send_icon === 'fa-solid fa-paper-plane'}"
                                                    (click)="embed.send_icon = 'fa-solid fa-paper-plane'; saveBotSettings()"></i>

                                                <!-- Few other Icon Options -->

                                                <i class="fa-light fa-paper-plane text-lg cursor-pointer"
                                                    [ngClass]="{'text-gray-400': embed?.send_icon !== 'fa-light fa-paper-plane', 'text-primary': embed?.send_icon === 'fa-light fa-paper-plane'}"
                                                    (click)="embed.send_icon = 'fa-light fa-paper-plane'; saveBotSettings()"></i>

                                                <i class="fa-solid fa-paper-plane-top text-lg cursor-pointer ml-3"
                                                    [ngClass]="{'text-gray-400': embed?.send_icon !== 'fa-solid fa-paper-plane-top', 'text-primary': embed?.send_icon === 'fa-solid fa-paper-plane-top'}"
                                                    (click)="embed.send_icon = 'fa-solid fa-paper-plane-top'; saveBotSettings()"></i>


                                                <i class="fa-light fa-paper-plane-top text-lg cursor-pointer"
                                                    [ngClass]="{'text-gray-400': embed?.send_icon !== 'fa-light fa-paper-plane-top', 'text-primary': embed?.send_icon === 'fa-light fa-paper-plane-top'}"
                                                    (click)="embed.send_icon = 'fa-light fa-paper-plane-top'; saveBotSettings()"></i>

                                                <i class="fa-solid fa-message-arrow-up text-lg ml-3 cursor-pointer"
                                                    [ngClass]="{'text-gray-400': embed?.send_icon !== 'fa-solid fa-message-arrow-up', 'text-primary': embed?.send_icon === 'fa-solid fa-message-arrow-up'}"
                                                    (click)="embed.send_icon = 'fa-solid fa-message-arrow-up'; saveBotSettings()"></i>


                                                <i class="fa-light fa-message-arrow-up text-lg cursor-pointer"
                                                    [ngClass]="{'text-gray-400': embed?.send_icon !== 'fa-light fa-message-arrow-up', 'text-primary': embed?.send_icon === 'fa-light fa-message-arrow-up'}"
                                                    (click)="embed.send_icon = 'fa-light fa-message-arrow-up'; saveBotSettings()"></i>


                                            </div>

                                        </div>



                                        <hr class="w-full h-1 bg-gray-100 mt-4">

                                        <div class="w-full mt-3 flex flex-col">

                                            <label class="edit_bot_label text-base font-normal mb-1">Chat Bubble
                                                Background
                                                Color</label>
                                            <input type="color" class=" mt-1" value="embed.bubble_bg_color"
                                                [(ngModel)]="embed.bubble_bg_color" />

                                        </div>

                                        <div class="w-full mt-3 flex flex-col">

                                            <label class="edit_bot_label text-base font-normal mb-1">Chat Bubble Icon
                                                Color</label>
                                            <input type="color" class=" mt-1" value="embed.bubble_text_color"
                                                [(ngModel)]="embed.bubble_text_color" />

                                        </div>


                                        <div class="w-full mt-3 flex flex-col">

                                            <label class="edit_bot_label text-base font-normal mb-1">Chat Bubble Icon
                                            </label>

                                            <div class="flex gap-x-4">

                                                <i class="fa-light fa-message text-lg cursor-pointer"
                                                    [ngClass]="{'text-gray-400': embed?.send_icon !== 'fa-light fa-message', 'text-primary': embed?.send_icon === 'fa-light fa-message'}"
                                                    (click)="embed.bubble_icon = 'fa-light fa-message'; saveBotSettings()"></i>

                                                <i class="fa-solid fa-message text-lg cursor-pointer"
                                                    [ngClass]="{'text-gray-400': embed?.send_icon !== 'fa-solid fa-message', 'text-primary': embed?.send_icon === 'fa-solid fa-message'}"
                                                    (click)="embed.bubble_icon = 'fa-solid fa-message'; saveBotSettings()"></i>

                                                <i class="fa-solid fa-messages text-lg cursor-pointer"
                                                    [ngClass]="{'text-gray-400': embed?.send_icon !== 'fa-solid fa-messages', 'text-primary': embed?.send_icon === 'fa-solid fa-messages'}"
                                                    (click)="embed.bubble_icon = 'fa-solid fa-messages'; saveBotSettings()"></i>

                                                <i class="fa-light fa-messages text-lg cursor-pointer"
                                                    [ngClass]="{'text-gray-400': embed?.send_icon !== 'fa-light fa-messages', 'text-primary': embed?.send_icon === 'fa-light fa-messages'}"
                                                    (click)="embed.bubble_icon = 'fa-light fa-messages'; saveBotSettings()"></i>

                                                <i class="fa-light fa-message-quote text-lg cursor-pointer"
                                                    [ngClass]="{'text-gray-400': embed?.send_icon !== 'fa-light fa-message-quote', 'text-primary': embed?.send_icon === 'fa-light fa-message-quote'}"
                                                    (click)="embed.bubble_icon = 'fa-light fa-message-quote'; saveBotSettings()"></i>

                                                <i class="fa-solid fa-message-quote text-lg cursor-pointer"
                                                    [ngClass]="{'text-gray-400': embed?.send_icon !== 'fa-solid fa-message-quote', 'text-primary': embed?.send_icon === 'fa-solid fa-message-quote'}"
                                                    (click)="embed.bubble_icon = 'fa-solid fa-message-quote'; saveBotSettings()"></i>

                                                <i class="fa-light fa-circle-info text-lg cursor-pointer"
                                                    [ngClass]="{'text-gray-400': embed?.send_icon !== 'fa-light fa-circle-info', 'text-primary': embed?.send_icon === 'fa-light fa-circle-info'}"
                                                    (click)="embed.bubble_icon = 'fa-light fa-circle-info'; saveBotSettings()"></i>

                                                <i class="fa-solid fa-circle-info text-lg cursor-pointer"
                                                    [ngClass]="{'text-gray-400': embed?.send_icon !== 'fa-solid fa-circle-info', 'text-primary': embed?.send_icon === 'fa-solid fa-circle-info'}"
                                                    (click)="embed.bubble_icon = 'fa-solid fa-circle-info'; saveBotSettings()"></i>







                                            </div>

                                            <div class="w-full h-40">

                                            </div>


                                        </div>






                                    </div>
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
            </div>





        </div>

    </div>

    <section class="py-20 bg-white sm:py-16 lg:py-20 mt-10 mb-24">
        <div class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
            <div class="grid items-center grid-cols-1 text-center lg:text-left gap-y-10 lg:grid-cols-5">
                <div class=" lg:col-span-2 lg:pr-8 xl:pr-24">
                    <h2 class="text-2xl font-bold text-gray-900 font-pj">
                        Private Hosted Solution
                    </h2>
                    <p class="mt-1 text-base font-normal leading-7 text-gray-600 font-pj">
                        With self-hosted or private-hosted version of Knibble.ai, you will gain the flexibility to
                        customize
                        the
                        solution to fit your specific needs, ensuring a seamless integration into your existing
                        infrastructure.
                    </p>

                    <p class="mt-2 text-base font-normal leading-7 text-gray-600 font-pj">
                        Reach us at support@knibble.ai
                    </p>

                    <div class="flex items-center justify-center mt-4 space-x-5 ">
                        <div class="relative inline-flex group">
                            <div
                                class="absolute transitiona-all duration-1000 opacity-70 -inset-px bg-gradient-to-r from-[#44BCFF] via-[#FF44EC] to-[#FF675E] rounded-xl blur-lg filter group-hover:opacity-100 group-hover:-inset-1 group-hover:duration-200 ">

                            </div>

                            <a href="https://knibble.notion.site/Knibble-ai-Private-Self-Hosted-97b3b31bc5be4a56b5a672d0b452b5cb?pvs=4"
                                target="_blank" title=""
                                class="relative inline-flex items-center justify-center px-5 py-2 text-base font-bold text-white transition-all duration-200 bg-gray-900 border-2 border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900 font-pj hover:bg-gray-600 rounded"
                                role="button">
                                Learn more
                            </a>
                        </div>


                    </div>
                </div>

                <div class="lg:col-span-3 lg:pl-8 xl:pl-24">
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-y-5 gap-x-6">
                        <div class="bg-white border border-gray-200 shadow-md rounded-2xl">
                            <div class="px-8 py-6">
                                <svg class="w-12 h-12 mx-auto text-gray-900 lg:mx-0" xmlns="http://www.w3.org/2000/svg"
                                    fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
                                        d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" />
                                </svg>
                                <h3 class="mt-8 text-lg font-bold text-gray-900 lg:mt-12 font-pj">
                                    Private Hosted
                                </h3>
                                <p class="mt-4 text-base font-normal leading-7 text-gray-700 font-pj">
                                    We deploy a private hosted version of Knibble.ai and manage the infrastructure for
                                    you.
                                </p>
                            </div>
                        </div>

                        <div class="bg-white border border-gray-200 shadow-md rounded-2xl">
                            <div class="px-8 py-6">
                                <svg class="w-12 h-12 mx-auto text-gray-900 lg:mx-0" xmlns="http://www.w3.org/2000/svg"
                                    fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
                                        d="M14 10l-2 1m0 0l-2-1m2 1v2.5M20 7l-2 1m2-1l-2-1m2 1v2.5M14 4l-2-1-2 1M4 7l2-1M4 7l2 1M4 7v2.5M12 21l-2-1m2 1l2-1m-2 1v-2.5M6 18l-2-1v-2.5M18 18l2-1v-2.5" />
                                </svg>
                                <h3 class="mt-8 text-lg font-bold text-gray-900 lg:mt-12 font-pj">
                                    Self Hosted
                                </h3>
                                <p class="mt-4 text-base font-normal leading-7 text-gray-700 font-pj">
                                    You have the flexibility and control to host and manage the application within your
                                    own
                                    infrastructure
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="py-9 bg-black overflow-hidden">
        <div class="container px-4 mx-auto">
            <div class="flex flex-wrap items-center justify-between -m-4">
                <div class="w-auto p-4">
                    <div class="flex flex-wrap items-center -m-7">
                        <div class="w-auto p-7">
                            <a href="#">
                                <img src="assets/logo-re2.svg" alt="" style="width:25px">
                            </a>
                        </div>
                        <div class="w-auto p-7">
                            <p class="text-sm text-white tracking-tight">© Copyright 2023 Knibble.ai</p>
                        </div>
                    </div>
                </div>
                <div class="w-auto p-4">
                    <div class="flex flex-wrap items-center -m-4">
                        <div class="w-auto p-4">
                            <ul class="flex flex-col md:flex-row flex-wrap -m-4">
                                <!-- <li class="p-4"><a
                                        class="text-sm text-white hover:text-gray-300 tracking-tight transition duration-200"
                                        href="#">About</a></li>
                                <li class="p-4"><a
                                        class="text-sm text-white hover:text-gray-300 tracking-tight transition duration-200"
                                        href="#">Services</a></li> -->
                                <li class="p-4"><a
                                        class="text-sm text-white hover:text-gray-300 tracking-tight transition duration-200"
                                        href="/privacy">Privacy Policy</a></li>
                                <li class="p-4"><a
                                        class="text-sm text-white hover:text-gray-300 tracking-tight transition duration-200"
                                        href="/termsandconditions">Terms &amp; Conditions</a></li>
                                <li class="p-4"><a
                                        class="text-sm text-white hover:text-gray-300 tracking-tight transition duration-200"
                                        href="#">support@knibble.ai</a></li>
                            </ul>
                        </div>
                        <div class="w-auto p-4" *ngIf="!mobile">
                            <div class="h-4 w-px bg-white bg-opacity-20"></div>
                        </div>
                        <div class="w-auto p-4">
                            <ul class="flex flex-wrap items-center -m-4">
                                <li class="p-4">
                                    <a class="text-white hover:text-gray-300 transition duration-200"
                                        href="https://twitter.com/knibble_ai">
                                        <svg width="14" height="12" viewbox="0 0 14 12" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M13.6488 1.81473C13.137 2.04222 12.5967 2.18439 12.028 2.2697C12.5967 1.92847 13.0517 1.38821 13.2507 0.734202C12.7105 1.04699 12.1133 1.27447 11.4593 1.41664C10.9475 0.876377 10.2082 0.535156 9.41201 0.535156C7.87652 0.535156 6.62537 1.7863 6.62537 3.32179C6.62537 3.54927 6.65381 3.74832 6.71068 3.94737C4.40744 3.83363 2.33168 2.72466 0.938358 1.01855C0.710877 1.44508 0.568702 1.90004 0.568702 2.41187C0.568702 3.37866 1.0521 4.23172 1.81985 4.74355C1.36488 4.71511 0.938358 4.60137 0.540266 4.40233V4.43076C0.540266 5.79564 1.50706 6.93305 2.78664 7.18896C2.55916 7.24583 2.30324 7.27427 2.04733 7.27427C1.87672 7.27427 1.67767 7.24583 1.50706 7.2174C1.87672 8.32637 2.90038 9.15098 4.12309 9.15098C3.15629 9.8903 1.96202 10.3453 0.654007 10.3453C0.426526 10.3453 0.199046 10.3453 0 10.3168C1.25114 11.113 2.70133 11.568 4.2937 11.568C9.44045 11.568 12.2555 7.3027 12.2555 3.60614C12.2555 3.4924 12.2555 3.35023 12.2555 3.23649C12.7958 2.86683 13.2792 2.38344 13.6488 1.81473Z"
                                                fill="currentColor"></path>
                                        </svg>
                                    </a>
                                </li>
                                <!-- <li class="p-4">
                                    <a class="text-white hover:text-gray-300 transition duration-200" href="#">
                                        <svg width="8" height="16" viewbox="0 0 8 16" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M2.34923 15.2006V8.41702H0.0664062V5.77332H2.34923V3.82367C2.34923 1.56111 3.73112 0.329102 5.74948 0.329102C6.71629 0.329102 7.54722 0.401083 7.78937 0.433256V2.79776L6.38954 2.7984C5.29184 2.7984 5.0793 3.32001 5.0793 4.08543V5.77332H7.6972L7.35634 8.41702H5.07929V15.2006H2.34923Z"
                                                fill="currentColor"></path>
                                        </svg>
                                    </a>
                                </li> -->
                                <li class="p-4">
                                    <a class="text-white hover:text-gray-300 transition duration-200"
                                        href="https://instagram.com/knibble.ai">
                                        <svg width="18" height="17" viewbox="0 0 18 17" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M8.79023 1.71659C10.9996 1.71659 11.2612 1.72487 12.134 1.76466C12.6587 1.77108 13.1785 1.86744 13.6707 2.04955C14.0276 2.1872 14.3518 2.39806 14.6223 2.66856C14.8928 2.93907 15.1036 3.26322 15.2413 3.62014C15.4234 4.11233 15.5197 4.6321 15.5262 5.15686C15.5656 6.02963 15.5742 6.29127 15.5742 8.50059C15.5742 10.7099 15.566 10.9715 15.5262 11.8443C15.5197 12.3691 15.4234 12.8888 15.2413 13.381C15.1036 13.738 14.8928 14.0621 14.6223 14.3326C14.3518 14.6031 14.0276 14.814 13.6707 14.9516C13.1785 15.1337 12.6587 15.2301 12.134 15.2365C11.2616 15.2759 10.9999 15.2846 8.79023 15.2846C6.58052 15.2846 6.31888 15.2763 5.4465 15.2365C4.92175 15.2301 4.40198 15.1337 3.90979 14.9516C3.55286 14.814 3.22871 14.6031 2.95821 14.3326C2.68771 14.0621 2.47684 13.738 2.33919 13.381C2.15709 12.8888 2.06073 12.3691 2.05431 11.8443C2.01491 10.9715 2.00624 10.7099 2.00624 8.50059C2.00624 6.29127 2.01451 6.02963 2.05431 5.15686C2.06073 4.6321 2.15709 4.11233 2.33919 3.62014C2.47684 3.26322 2.68771 2.93907 2.95821 2.66856C3.22871 2.39806 3.55286 2.1872 3.90979 2.04955C4.40198 1.86744 4.92175 1.77108 5.4465 1.76466C6.31928 1.72526 6.58091 1.71659 8.79023 1.71659ZM8.79023 0.225586C6.54427 0.225586 6.26136 0.235043 5.37873 0.275234C4.69196 0.288894 4.01247 0.418928 3.36918 0.659806C2.81734 0.867721 2.31752 1.19354 1.90458 1.61454C1.4832 2.02763 1.1571 2.52774 0.949057 3.07993C0.708179 3.72322 0.578145 4.4027 0.564485 5.08948C0.525082 5.97131 0.515625 6.25423 0.515625 8.50019C0.515625 10.7462 0.525082 11.0291 0.565273 11.9117C0.578933 12.5985 0.708967 13.278 0.949845 13.9212C1.15766 14.4734 1.48349 14.9735 1.90458 15.3866C2.31774 15.8077 2.81785 16.1336 3.36997 16.3414C4.01326 16.5822 4.69275 16.7123 5.37952 16.7259C6.26214 16.7653 6.54387 16.7756 8.79102 16.7756C11.0382 16.7756 11.3199 16.7661 12.2025 16.7259C12.8893 16.7123 13.5688 16.5822 14.2121 16.3414C14.7616 16.1284 15.2606 15.803 15.6772 15.3862C16.0938 14.9693 16.4188 14.4701 16.6314 13.9205C16.8723 13.2772 17.0023 12.5977 17.016 11.9109C17.0554 11.0291 17.0648 10.7462 17.0648 8.50019C17.0648 6.25423 17.0554 5.97131 17.0152 5.08869C17.0015 4.40192 16.8715 3.72243 16.6306 3.07914C16.4228 2.52702 16.097 2.02692 15.6759 1.61375C15.2627 1.19266 14.7626 0.866832 14.2105 0.659018C13.5672 0.41814 12.8877 0.288106 12.2009 0.274446C11.3191 0.235043 11.0362 0.225586 8.79023 0.225586Z"
                                                fill="currentColor"></path>
                                            <path
                                                d="M8.78827 4.25146C7.94786 4.25146 7.12632 4.50068 6.42754 4.96759C5.72876 5.43449 5.18413 6.09813 4.86252 6.87457C4.5409 7.65101 4.45676 8.50539 4.62071 9.32965C4.78467 10.1539 5.18937 10.9111 5.78363 11.5053C6.37789 12.0996 7.13503 12.5043 7.95929 12.6682C8.78356 12.8322 9.63793 12.748 10.4144 12.4264C11.1908 12.1048 11.8545 11.5602 12.3214 10.8614C12.7883 10.1626 13.0375 9.34109 13.0375 8.50067C13.0375 7.37371 12.5898 6.29291 11.7929 5.49603C10.996 4.69915 9.91523 4.25146 8.78827 4.25146ZM8.78827 11.2589C8.24275 11.2589 7.70948 11.0971 7.2559 10.794C6.80231 10.491 6.44879 10.0602 6.24003 9.55619C6.03126 9.0522 5.97664 8.49761 6.08307 7.96257C6.18949 7.42754 6.45219 6.93607 6.83793 6.55033C7.22367 6.16459 7.71513 5.90189 8.25017 5.79547C8.78521 5.68904 9.3398 5.74366 9.84379 5.95243C10.3478 6.16119 10.7786 6.51471 11.0816 6.9683C11.3847 7.42188 11.5465 7.95515 11.5465 8.50067C11.5465 9.23219 11.2559 9.93375 10.7386 10.451C10.2214 10.9683 9.51979 11.2589 8.78827 11.2589Z"
                                                fill="currentColor"></path>
                                            <path
                                                d="M13.2078 5.07624C13.7562 5.07624 14.2007 4.63168 14.2007 4.08328C14.2007 3.53489 13.7562 3.09033 13.2078 3.09033C12.6594 3.09033 12.2148 3.53489 12.2148 4.08328C12.2148 4.63168 12.6594 5.07624 13.2078 5.07624Z"
                                                fill="currentColor"></path>
                                        </svg>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>